<template>
	<div>
		<div class="bb-next-buttons">
			<div class="uk-flex uk-flex-middle">
				<button v-if="prev_route !=''" @click.prevent="goBack">Back</button>
				<button v-if="next_route !=''" class="blue" @click.prevent="goNext">Next</button>
            </div>
		</div>
	</div>
</template>

<script>
import {EventBus} from "../main";
	export default {
		name : "next-buttons",
		components: {},
		props: {
			next_route: {
				type: String,
				default : ""
			},
			prev_route: {
				type : String,
				default : ""
			}
		},
    methods:{
      goNext(){
        if(this.next_route != ''){
          EventBus.$emit("navigate", this.next_route);
        }
      },
      goBack(){
        if(this.prev_route != ''){
          EventBus.$emit("navigate", this.prev_route);
        }
      }
    }
	}
</script>